import React from "react";

import { openStoreLocatorPanel } from "../../../utils/domManipulation";
import { useAppSelector } from "../../reducers";
import { myStoreSelector } from "../../retail/selectors";

import styles from "./TryInStoreCallout.module.scss";

interface IOwnProps {
    cssClass?: string;
}

const TryInStoreCalloutPresentation = (props: {
    cssClass?: string;
    name: string;
}): React.ReactNode => {
    return (
        <p className={props.cssClass ? props.cssClass : styles.root}>
            Try in-store at{" "}
            <button onClick={openStoreLocatorPanel} className={styles.button}>
                {props.name}
            </button>
        </p>
    );
};

export const TryInStoreCallout = (props: IOwnProps): React.ReactNode => {
    const store = useAppSelector(myStoreSelector);

    if (!store) {
        return null;
    }

    return (
        <TryInStoreCalloutPresentation
            cssClass={props.cssClass}
            name={store.name}
        />
    );
};

export const TryInStoreCalloutContainer = TryInStoreCallout;
